<div class="container">
  <div class="h4">{{ 'errors.standard.pageNotFoundTitle' | translate }}</div>
  <div>{{ 'errors.standard.pageNotFoundParagraph1' | translate }}</div>
  <div>{{ 'errors.standard.pageNotFoundParagraph2' | translate }}</div>
</div>
